module.exports = __webpack_public_path__ + "img/statistics-graph.ae411920.svg";